module.exports = "<a [href]=\"socialMediaData.href\" [class]=\"socialMediaData.class\" target=\"_blank\">{{socialMediaData.displayText}}</a>"